Vue.component('web-callback-form', {
  props: ['options', 'labellang'],
  template: '<transition v-if="isActive" name="bounce" enter-active-class="bounceInUp" leave-active-class="bounceOutRight" v-bind:css="options.internal.isAnimationCompatibility">' +
    '<div id="web-callback-form" >' +
          '<button-popover :options="options"></button-popover>'+
          '<div v-if="boxSuccess" class="box-success text-center offset-top-100"><i class="material-icons md-48">&#xE876;</i>'+
            '<h3>{{ text.successTitle }}</h3>'+
            '<p>{{ text.successSubtitle }}</p>'+
          '</div>'+
          '<form @submit.prevent="sendForm" v-if="formVisible">' +
			    '<div class="overlay-content">' +
                  '<div class="offset-top-10"><h3> {{ text.title }} </h3></div>' +
                  '<div v-if="haveChoiseDate" class="day-card result text-center">'+
                      '<div class="col-xs-6"><i class="material-icons md-48 offset-top-30">&#xE85D;</i></div>'+
                      '<div class="col-xs-6">'+
                      '<h3> {{ currentChoise.name }} </h3>'+
                      '<h4> {{ currentChoise.date_number }} {{ currentChoise.month.name }}</h4>'+
                      '<p>{{ currentChoise.name }} {{ currentChoise.date_number }} {{ currentChoise.month.name }} <span v-if="currentChoise.hours < 10">0</span>{{ currentChoise.hours }}:<span v-if="currentChoise.minutes < 10">0</span>{{ currentChoise.minutes }}</p>'+
                      '</div>'+
                  '</div>'+
                  '<div v-if="smallhaveChoiseDate" class="offset-top-10 text-center"> {{ currentChoise.name }} {{ currentChoise.date_number }} {{ currentChoise.month.name }} <span v-if="currentChoise.hours < 10">0</span>{{ currentChoise.hours }}:<span v-if="currentChoise.minutes < 10">0</span>{{ currentChoise.minutes }}</div>'+
                  '<ul class="list-unstyled" >' +
										    '<li v-for="(item, index) in getList" @init="infoCustomer[item.name] = \'\'">' +
										    '<label>{{ item.name }}</label>' +
										    '<template v-if="item.type === \'notes\'">' +
										    '<textarea class="col-xs-12 offset-top-10" :type="item.type" :required="item.required"  :placeholder="item.name" v-model="infoCustomer[item.name]" :tabindex="index + 1" :class="styleInput"></textarea>' +
										    '</template>' +
										    '<template v-else>' +
										    '<input class="col-xs-12 offset-top-10" ref="input" :type="item.type | filterInput" :required="item.required"  :placeholder="item.name" v-model="infoCustomer[item.name]" :tabindex="index + 1" :class="styleInput">' +
										    '</template>' +
										    '</li>' +
												'<div class="clearfix"></div>' +
									    '</ul>' +
			    '</div>' +
          '<div class="overlay-footer">'+
            '<button :disabled="sendDisable" class="pull-right btn btn-info" :click.prevent="sendForm" @keyup.enter="sendForm" >{{ text.send }}</button>' +
            '<button @click="closeView"  class="btn pull-left">{{ this.labellang.cancel }}</button>'+
          '</div>' +
          '<div v-if="hasError" class="error text-center">{{ this.msgError }}</div>'+
					'</form>' +
    '</div>' +
    '</transition>',
  data: function() {
    return {
      isActive: false,
      infoCustomer: {},
			hasSubTItle:true,
      formVisible:true,
      hasError:false,
      boxSuccess:false,
      haveChoiseDate:false,
      smallhaveChoiseDate:false,
      currentChoise:null,
      sendDisable:false,
      typeForm:'',
      formValid:true,
      msgError:'',
      text: {
        title: this.labellang.webcb_give_some_information,
        subtitle: '',
        successTitle: this.labellang.webcb_schedule_saved_title,
        successSubtitle: this.labellang.webcb_schedule_saved_subtitle,
        send:this.labellang.send,
      },
      styleInput: {
        active: true,
        'text-danger': false
      }
    }
  },
  filters: {
    filterInput: function(value) {
        if (value == "phone") {
            return "tel"
        }
        if (value == "email") {
            return "email"
        }
    },
  },
  mounted: function() {
    var that = this;

    bus.$on("onWebCallBackForm", function (val) {
        that.contentShow(val);
        that.checkCustomerInfo();

    });

    this.$parent.$on('onWebCallBackForm', function(val) {
        that.contentShow(val);
        that.checkCustomerInfo();
    });

    bus.$on("onWebCallBackFormDataChoise", function (data) {
        that.setDataChoise(data);
    });
    bus.$on("onWebCallBackFormNoData", function () {
        that.setNoDataChoise();
    });

  },
  computed: {
    getList: function() {
      return this.options.configuration.callbackDefinition;
    }
  },
  methods: {
    contentShow: function(val) {
      this.isActive = val;
    },
    setDataCustomer:function(data){
      this.infoCustomer = data;
    },
    checkCustomerInfo:function(){
      var callBackFiedls = this.options.configuration.callbackDefinition;
      var customerInfo = this.options.internal.customerInfo;
      for(var field in callBackFiedls){
        var name = callBackFiedls[field].name;
        for(var prop in customerInfo){
          if(name.toLowerCase().trim() === prop.toLowerCase().trim()){
            this.infoCustomer[name] = customerInfo[prop];
            break;
          }
        }
      }
    },
    setDataChoise:function(data){
        this.typeForm = "setTime";
        this.currentChoise = data;
 
        this.haveChoiseDate = true;

        if(this.options.configuration.callbackDefinition.length >= 3){
          this.haveChoiseDate = false;
          this.smallhaveChoiseDate = true;
        }

    },
    setNoDataChoise:function(){
        this.haveChoiseDate = false;
        this.smallhaveChoiseDate = false;

    },
    sendForm: function() {
      if( this.formValid  ){
          this.options.internal.customerInfo = this.infoCustomer;
          if(this.typeForm == "setTime"){
            this.sendRequestPlaned();
          }else {
            this.setAsap();
          }
      }else {
        this.hasError = true;
        this.msgError = this.labellang.webcb_error_form_field;
      }
    },
    isEmail: function(value) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value);
    },
    ifEmail:function(typeVal,inputVal){
      this.msgError = ''
      this.hasError = false;

      if(typeVal == "email"){
        if( typeof inputVal !== "undefined" && inputVal.length >= 1) {
          var isValid =  this.isEmail(inputVal);
          if(isValid  ){
            this.msgError = ''
            this.formValid = true;
          }else{
            this.msgError = this.labellang.emailNotValid
            this.formValid = false;
          }
        }
      }
    },
    closeView:function(){
      this.choise = '';
      this.isActive = false;
    },
    sendRequestPlaned: function() {
      var currentDate = new Date();
      var TodayDay =  currentDate.getDate();
      var curretDaySelecet = this.currentChoise.date_number;
      var dateSeted = new Date(this.currentChoise.year,this.currentChoise.month.number,this.currentChoise.date_number,this.currentChoise.hours,this.currentChoise.minutes);

      if( curretDaySelecet == TodayDay && dateSeted < currentDate ){
  //      console.log("is Today e sono minore del tempo attuale");
      //  console.log(dateSeted);
    //    console.log(currentDate);
        var setNewTime =  currentDate.getMinutes() + 5;
        currentDate.setMinutes(setNewTime);
    //    console.log("currentDate finale minore di quella settata");
      //  console.log(currentDate);
      }else{
        currentDate.setMonth(this.currentChoise.month.number);
        currentDate.setDate(this.currentChoise.date_number);
        currentDate.setHours(this.currentChoise.hours);
        currentDate.setMinutes(this.currentChoise.minutes);
      }


      this.options.internal.bridge.callBackRequest(this.infoCustomer, currentDate);
      this.boxSuccess = true;
      this.formVisible = false;

    },
    setAsap: function() {
      var currentDate = null;
      this.options.internal.bridge.callBackRequest(this.infoCustomer, currentDate);
      this.boxSuccess = true;
      this.formVisible = false;
    },
  }


})
